import { ChangeEvent } from 'react';

export const handleInputChange = (
  e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  callback: React.Dispatch<React.SetStateAction<string>>,
): void => {
  callback(e.target.value);
};
